import { AdditionalBankingData } from '../interfaces/AdditionalBankingData';
import { AddressDataRequest } from '../interfaces/AddressDataRequest';
import { AdmissionData } from '../interfaces/AdmissionData';
import { BankingData } from '../interfaces/BankingData';
import { Dependent } from '../interfaces/Dependent';
import { PersonalDataRequest } from '../interfaces/PersonalDataRequest';
import { PersonalDocument } from '../interfaces/PersonalDocument';
import { ProfessionalDocumentsRequest } from '../interfaces/ProfessionalDocumentsRequest';
import StepManager from '../services/util/step-manager/StepManager';

export class Admission implements AdmissionData {
  personal: PersonalDataRequest;
  address: AddressDataRequest;
  personalDocuments: PersonalDocument;
  professionalDocuments: ProfessionalDocumentsRequest;
  banking: BankingData;
  additionalBankingData: AdditionalBankingData;
  dependents: Dependent[];
  step?: string | undefined;


  constructor(personal: PersonalDataRequest | undefined, address: AddressDataRequest | undefined, personalDocuments: PersonalDocument | undefined, professionalDocuments: ProfessionalDocumentsRequest | undefined, banking: BankingData | undefined, additionalBankingData: AdditionalBankingData | undefined, dependents: Dependent[] | undefined, step: string | undefined) {
    this.personal = personal || {};
    this.address = address || {};
    this.personalDocuments = personalDocuments || {};
    this.professionalDocuments = professionalDocuments || {};
    this.banking = banking || {};
    this.additionalBankingData = additionalBankingData || {};
    this.dependents = dependents || [];
    this.step = step || StepManager.getFirstStep().id;
  }
}